import { useCallback } from "react";
import { useRemoteRenderContext } from "../classes/contexts/RemoteRenderContext";
import { PLANNING_STATES } from "../classes/enums/PlanningStateEnum";

const UseDataFusionActions = currentPlanId => {
  const { client: remoteRendererClient } = useRemoteRenderContext();

  const currentPlanIdInternal = currentPlanId || PLANNING_STATES.CHECK;

  const showCtFusionView = useCallback(
    async step => {
      if (remoteRendererClient) {
        await remoteRendererClient.ShowCtFusionView(
          currentPlanIdInternal,
          step.toLowerCase()
        );
      } else {
      }
    },
    [remoteRendererClient, currentPlanIdInternal]
  );

  const hideCtFusionView = useCallback(
    async step => {
      if (remoteRendererClient) {
        await remoteRendererClient.HideCtFusionView(
          currentPlanIdInternal,
          step.toLowerCase()
        );
      } else {
      }
    },
    [remoteRendererClient, currentPlanIdInternal]
  );

  const changeCtFusionSlice = useCallback(
    (sliceIndex, step, viewType) => {
      if (remoteRendererClient) {
        remoteRendererClient.ChangeCtFusionSlice(
          currentPlanIdInternal,
          sliceIndex,
          step,
          viewType
        );
      } else {
      }
    },
    [remoteRendererClient, currentPlanIdInternal]
  );

  const getFusionVisibilityState = useCallback(
    async step => {
      if (remoteRendererClient) {
        return await remoteRendererClient.GetFusionVisibilityState(
          currentPlanIdInternal,
          step.toLowerCase()
        );
      } else {
        return false;
      }
    },
    [remoteRendererClient, currentPlanIdInternal]
  );

  return {
    showCtFusionView,
    hideCtFusionView,
    changeCtFusionSlice,
    getFusionVisibilityState,
  };
};

export default UseDataFusionActions;
